import CmsApi from '../utilities/cms-api';
import CategoryFilter from '../components/category-filter';

export default class Offers {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.offers-element'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;

	/** @type {Array<any>} */
	#data = [];

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		const hotelId = parseInt(this.#holderElement.dataset.hotelId);
		CmsApi.fetchOffers()
			.then(offers => offers.filter(o => o.properties.find(p => p.id === hotelId)))
			.then(offers => offers.map(o => this.normaliseOffer(o)))
			.then(offers => {
				new CategoryFilter(this.#holderElement, this.#data, CategoryFilter.OFFER_TYPE);
			});
	}

	/**
	 * @param {Offer} offer
	 */
	normaliseOffer(offer) {
		let categories = [];
		offer.categories.forEach((category) => {
			categories.push({
				'id': category.id,
				'name': category.title,
				'content': category.description,
			});
		});
		this.#data.push({
			'id': offer.id,
			'name': offer.name,
			'slug': offer.slug,
			'categories': categories,
			'content': offer.excerpt,
			'image': offer.image,
			'address': null,
			'email': null,
			'phone': null,
			'website': offer.bookingLink,
			'link': offer.link,
			'latitude': null,
			'longitude': null,
			'start': offer.start,
			'end': offer.end,
			'tags': null
		});
	}
}
